import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { PRODUCT_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddProductTypeForm from "./addProductTypeForm.component";
import ProductTypeList from "./productTypeList.component";

const ProductTypeConfig = () => {
  // const { auth } = useAuth();
  const [productTypeList, setProductTypeList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editProductTypeDetails, setEditProductTypeDetails] = useState({});
  const isEdit = Object.keys(editProductTypeDetails).length > 0 ? true : false;

  const getProductTypeList = async () => {
    try {
      const response = await axios.get(PRODUCT_TYPE_CONFIG_URL);
      // console.log("Product Type List", { response });
      response.status === 200 &&
        setProductTypeList(response.data.productTypeList);
      response.status === 202 &&
        showToast("No product type found in the system.", "error");
    } catch (error) {
      console.error("getProductTypeList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getProductTypeList();
      setEditProductTypeDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Product Type"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${
          isEdit ? "Update Product Type Details" : "Add Product Type Details"
        }`}
        isAdd={true}
        clearData={setEditProductTypeDetails}
      >
        <AddProductTypeForm
          getProductTypeList={getProductTypeList}
          editProductTypeDetails={editProductTypeDetails}
          setEditProductTypeDetails={setEditProductTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <ProductTypeList
          productTypeList={productTypeList}
          getProductTypeList={getProductTypeList}
          setEditProductTypeDetails={setEditProductTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default ProductTypeConfig;
